'use client';

import { Column } from '@vuddy/components';
import { useState } from 'react';
import {
  OptionCategoryDropdown,
  OptionCategoryDropdownOption,
} from './OptionCategoryDropdown';

export interface OptionCategoryForDropdown {
  id: number;
  name: string;
  options: OptionCategoryDropdownOption[];
}

interface OptionCategoryDropdownListProps {
  categories: OptionCategoryForDropdown[];
  selectedIds: Record<number, (string | number)[]>;
  onSelect: (categoryId: number, optionId: string | number) => void;
  onComplete: (categoryId: number) => void;
  hasParentWidth?: boolean;
  isCompleteDisabledMap?: Record<number, boolean>;
  /** 외부 제어 모드: 현재 열린 카테고리 ID */
  openedCategoryId?: number | null;
  /** 외부 제어 모드: 열린 카테고리 변경 콜백 */
  onOpenedCategoryChange?: (id: number | null) => void;
}

export const OptionCategoryDropdownList = ({
  categories,
  selectedIds,
  onSelect,
  onComplete,
  hasParentWidth = true,
  isCompleteDisabledMap,
  openedCategoryId: controlledOpenedId,
  onOpenedCategoryChange,
}: OptionCategoryDropdownListProps) => {
  const [internalOpenedId, setInternalOpenedId] = useState<number | null>(null);

  const isControlled = controlledOpenedId !== undefined;
  const openedId = isControlled ? controlledOpenedId : internalOpenedId;
  const setOpenedId = isControlled
    ? (id: number | null) => onOpenedCategoryChange?.(id)
    : setInternalOpenedId;

  return (
    <Column gap="gap_base">
      {categories.map(category => (
        <OptionCategoryDropdown
          key={category.id}
          hasParentWidth={hasParentWidth}
          categoryName={category.name}
          open={openedId === category.id}
          onOpenChange={open => setOpenedId(open ? category.id : null)}
          options={category.options}
          selectedIds={selectedIds[category.id] ?? []}
          onSelect={id => onSelect(category.id, id)}
          isCompleteDisabled={isCompleteDisabledMap?.[category.id]}
          onComplete={() => {
            onComplete(category.id);
            setOpenedId(null);
          }}
        />
      ))}
    </Column>
  );
};
